/* Copyright (C) 2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

import * as React from 'react';
import { NavDropdown, NavDropdownProps, Dropdown } from 'react-bootstrap';
import { ReplaceProps } from 'react-bootstrap/helpers';

interface INavItemState
{
	show: boolean;
}

class NavItem extends React.Component<ReplaceProps<typeof Dropdown, NavDropdownProps>, INavItemState>
{
	state =
	{
		show: false
	};

	render()
	{
		const { show } = this.state;
		const {  onMouseEnter, onMouseLeave  } = this.props;
		return (
			<NavDropdown {...this.props}
				show={show}
				onMouseEnter={ () => this.setState({ show: true  }) }
				onMouseLeave={ () => this.setState({ show: false }) }
				>
				{ this.props.children }
			</NavDropdown>
		)
	}
}

export default NavItem;
